import { render } from "./agent-details.vue?vue&type=template&id=7bd0d6c6&scoped=true"
import script from "./agent-details.vue?vue&type=script&lang=js"
export * from "./agent-details.vue?vue&type=script&lang=js"

import "./agent-details.vue?vue&type=style&index=0&id=7bd0d6c6&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd0d6c6"]])

export default __exports__